export const PRESETS = [
  { key: 'morning', label: '🌅 9am',  localHour: 9  },
  { key: 'noon',    label: '🌞 Noon', localHour: 12 },
  { key: 'evening', label: '🌆 6pm',  localHour: 18 },
  { key: 'night',   label: '🌙 9pm',  localHour: 21 },
];

// offsetMinutes defaults to the browser's current timezone offset.
// Injectable for testing: pass e.g. 300 for UTC-5, -300 for UTC+5.
export function localHourToUTC(localHour, offsetMinutes = new Date().getTimezoneOffset()) {
  const utcOffset = offsetMinutes / 60;
  return (localHour + utcOffset + 24) % 24;
}
